import { ClassNameProps } from "@/types";
import { StreamingIcons } from "@/assets/iconFont/streaming-icons";

enum RailVariant {
  Hero169 = "hero169",
  Hero34 = "hero34",
  ShowcaseCarousel = "showcase-carousel",
}

interface RailProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  /**
   * Visual style of the rail, defaults to Hero34
   */
  variant?: RailVariant;

  /**
   * Optional rail title text
   */
  title?: string;

  /**
   * Optional rail icon
   */
  icon?: StreamingIcons;

  /**
   * Whether the rail should be free scrolling or snap to each tile's position
   * Defaults to false
   */
  snap?: boolean;
}

export { RailVariant };
export type { RailProps };
